import React from 'react'
import type { PageConfig } from 'models/pages'
import {
  useInternalAnalytics,
  buildMParticleGlobalProperties,
  buildMParticleDonationProperties,
} from '.'

export const useMParticleLogDonationFunnelStartViewed = (
  pageConfig: PageConfig,
  loggedInState: boolean,
) => {
  const { mParticle, consentSynced } = useInternalAnalytics()
  const hasLoggedDonationFunnelStartViewed = React.useRef(false)

  React.useEffect(() => {
    if (!mParticle || !consentSynced) return

    const globalProperties = buildMParticleGlobalProperties(pageConfig, mParticle, loggedInState)
    const keyDonationProperties = buildMParticleDonationProperties(pageConfig)

    mParticle.logEvent(
      'Donation Funnel Start Viewed',
      mParticle.EventType.Other,
      {
        ...globalProperties,
        ...keyDonationProperties,
      },
      {
        'GA4.Title': document.title,
        'GA4.Location': document.location.href,
        'GA4.Referrer': document.referrer,
      },
    )

    hasLoggedDonationFunnelStartViewed.current = true
  }, [consentSynced, loggedInState, mParticle, pageConfig])
}
